import { ConfigProvider } from '../../providers/config/config';
import { LogLevel } from '../../models/models';

//NOTE sembra che sia bacato e vada in loop
//import safeStringify from 'fast-safe-stringify';
import moment from 'moment';

let safeStringify: (any) => string = (value) => {
	const seen = new WeakSet();
	let decycler = (_, value) => {
		if (typeof value === "object" && value !== null) {
			if (seen.has(value)) {
				return;
			}
			seen.add(value);
		}
		return value;
	}

	return JSON.stringify(value, decycler);
};

//supporto per i plugin cordova
declare var window: any;

/**
Classe senza dipendenze da provider, utilizzabile a qualunque livello
*/
export class Logger {
	/**
	Flag per attivare il log remoto degli errori
	*/
	public static remoteStoreErrors = false;
	public static remoteStoreDebugs = false;
	private static groups: string[] = []

	private static _instance = new Logger();
	public static get instance(): Logger {
		return Logger._instance;
	}

	/*
	private static stringify(o) {
	try {
	return JSON.stringify(o)
} catch (_) {
try {
return safeStringify(o)
} catch (e) {
return o + '; Valore impossibile da serializzabile a causa di: ' + e.toString();
}
}
}
*/

	/**
	Contesto di log
	*/
	private static getContext(minDepth = 0): any {
		let data: any = {
			appContext: window.appContext,
			stackTrace: Logger.instance.getStack(minDepth + 1)
		};

		return data;
	}

	/*
	Fornisce lo stack
	**/
	public getStack(minDepth = 0, maxDepth = 100): any[] | string {
		let caller;
		minDepth += 2;

		try {
			caller = (<any>arguments).callee.caller//attraverso arguments
		} catch (e) { }

		if (!caller) {
			try {
				caller = (<any>this).caller//diretto
			} catch (e) { }
		}

		if (!caller) {
			try {
				caller = this.getStack.caller//via prototipo funzione
			} catch (e) { }
		}

		if (caller) {
			let stack: any[] = [];
			while (maxDepth > 0 && caller && caller.caller) {//prova con caller
				maxDepth--;
				caller = caller.caller;
				if (minDepth <= 0) {
					(<any[]>stack).push(caller);
				}
				minDepth--;
			}
		}

		let stack: string = null;
		let e = new Error;
		stack = e.stack;

		let lines = stack.split('\n');
		// remove one line, starting at the first position
		lines.splice(0, minDepth)
		stack = lines.join('\n')
		return stack;
	}

	public static debug(message: any, details: any = null, caller = null) {
		if (Logger.remoteStoreDebugs) {
			Logger.store(LogLevel.DEBUG, message, null, 1, caller)
		}

		if (details) console.debug(message, details)
		else console.debug(message)
	}

	public static enter(title: any = null, caller = null) {
		let datetimems = moment().format("Y-MM-DD HH:MM:ss.SSS");
		if (!caller) caller = Logger.instance.getCaller(1)
		if (title) {
			caller += ': ' + title
		}
		Logger.groups.push('[' + datetimems + '] ' + caller);
		console.group(caller)
	}

	public static error(message: any, error: Error = null, caller = null) {
		if (Logger.remoteStoreErrors) {
			Logger.store(LogLevel.ERROR, message, error, caller)
		}

		try {
			console.error(message, error)
		} catch (e2) {
			console.error(message)
		}
	}

	public static exit() {
		if (Logger.groups.length > 0) {
			Logger.groups.pop()
		}
		console.groupEnd()
	}

	private getCaller(minDepth: number = 0): string {
		let caller: string = null;
		//salta se stesso
		let stack = this.getStack(minDepth + 1)
		try {
			if (typeof stack === 'string') {
				let tokens = stack.split("\n")[0].trim().split(' ');
				caller = tokens[2] + '.' + tokens[1] + '()';//classe.metodo
			} else {
				let callerEntry = stack[0];
				if (callerEntry.name) {
					return callerEntry.name;
				}

				let callerString: string = callerEntry.toString();

				//let functionNameMatch = callerString.match(/function ([^\(]+)/);
				//caller = functionNameMatch === null ? 'Document Object Model' : functionNameMatch[1]
				caller = callerString;
			}
		} catch (e) {
			try {
				if (stack) caller = stack.toString();
			} catch (e) {
				caller = 'undefined';
			}
		}
		return caller;
	}
	/**
	Invia un log al server
	NON usa i servizi Angular iniettabili ma oggetti DOM puliti, per non avere dipendenze di injection
	*/
	public static store(
		level: LogLevel,
		message: string,
		error: Error = null,
		minDepth: number = 0,
		caller: any = null
	) {
		//RIMOSSO PERCHE DESTABILIZZA TUTTO SE NON RIESCE A SALVARE, ANCHE CON TRY CATCH
		//TODO Provare a sostituirlo con JL() o un altro logger remoto

		console.debug('[Logger.store()]');

		try {
			try {
				if (!caller) {
					caller = Logger.instance.getCaller(minDepth + 1)
				}
			} catch (e) {
				console.error("Errore recuperando il chiamante per contestualizzare il log", e);
			}

			let context = {};
			try {
				context = Logger.getContext(minDepth + 1);
			} catch (e) {
				console.error("Errore recuperando lo stack delle chiamate per contestualizzare il log", e);
			}

			var xhr = new XMLHttpRequest();
			xhr.onload = () => { console.debug('Log inviato al server') };
			xhr.ontimeout = () => { console.warn('Timeout inviando il log al server') };
			xhr.onreadystatechange = () => {
				if (xhr.readyState === XMLHttpRequest.DONE && xhr.status !== 200) {
					console.warn('Errore del server salvando il log: ' + xhr.responseText);
				}
			}

			xhr.open('POST', ConfigProvider.HOST + "/log/store");
			xhr.setRequestHeader('Content-Type', 'application/json');

			let log = {
				error: error,
				message: message,
				context: {
					'groups': Logger.groups.length > 0 ? Logger.groups : null,
					'caller': caller,
					'context': context,
				},
				level: level
			};
			/*
			if (error) {
				log.error = {
					'type': typeof error,
					'name': error.name,
					'message': error.message,
					'stack': error.stack,
				};
			}
			*/
			xhr.send(safeStringify(log));

		} catch (er) {
			console.error('Errore inviando il log al server', error, er)
		}
	}
}



// WEBPACK FOOTER //
// ./src/util/logger/logger.ts